import { ActionType, createAction } from 'typesafe-actions'
import { OrganizationLocator } from 'scenes/Dashboard/data/organizations/types'

export const showAddOrganizationModal = createAction(
  '/scenes/Dashboard/scenes/OrganizationsManager/components/AddOrganizationModal/SHOW'
)

export const hideAddOrganizationModal = createAction(
  '/scenes/Dashboard/scenes/OrganizationsManager/components/AddOrganizationModal/HIDE'
)

export const submitAddOrganizationForm = createAction(
  '/scenes/Dashboard/scenes/OrganizationsManager/components/AddOrganizationModal/SUBMIT_FORM',
  (resolve) => ({ organization, isCreated }: { organization: OrganizationLocator; isCreated: boolean }) =>
    resolve({ organization, isCreated })
)

export type AddOrganizationModalAction = ActionType<
  typeof showAddOrganizationModal | typeof hideAddOrganizationModal | typeof submitAddOrganizationForm
>
